import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import GroupFolderRulePermissionStore from './schema/GroupFolderRulePermissionStore';
import GroupFolderAndRulePermission from './schema/GroupFolderAndRulePermission';

const defaultGroupFolderRulePermissionStore: GroupFolderRulePermissionStore = {
    folderRulePermissionTable: new ObservableMap<string, GroupFolderAndRulePermission>({}),
};

export const getGroupFolderRulePermissionStore = createStore<GroupFolderRulePermissionStore>(
    'GroupFolderRulePermissionStore',
    defaultGroupFolderRulePermissionStore
);
